import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicAreaCharts } from "../../../../Constant";
import Chart from 'react-apexcharts';
import { BASIC_AREA_CHART } from "../../../../Data/Charts/ApexChart";

const BasicAreaChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={BasicAreaCharts} />
        <CardBody>
          <div id="basic-apex">
          <Chart options={BASIC_AREA_CHART} series={BASIC_AREA_CHART.series} type="area" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicAreaChart;